<template>
    <v-select
        id="order"
        class="search-order-form"
        :placeholder="placeholder"
        :filterable="false"
        :filter="fuseOrdersSearchFilter"
        :getOptionLabel="option => option.reference"
        :options="orders"
        @search="onSearch"
        @input="onSearchInput">
        <div slot="no-options">
            <template v-if="search">
                Aucun résultat ne correspond à votre recherche
            </template>
            <template v-else>
                {{placeholder}}
            </template>
        </div>
        <template #option="order">
            <OrderIcon :type="order.final_customer_type" :online="order.online ? true : false"></OrderIcon>
            {{ order.subcustomer && order.subcustomer.name ? order.subcustomer.name : order.customer.name }}
            <UnpaidOrderIcon v-if="!order.paid_at && order.final_customer_type === 'pickup_point_subcustomer'"></UnpaidOrderIcon>
            <HasPriority v-if="order.customer.has_priority"></HasPriority>
            <template v-if="order.preparable">
                - <span :class="'preparation-color-'+order.preparation_status.color">{{ order.status_label }}</span>
            </template>
            <template v-else>
                - <small>Non préparable</small>
            </template>
            <br>
            <span class="text-muted">{{ global.moment(order.delivery_date).format('ddd Do MMM YY') }}</span>
            - <cite>{{ order.reference }}</cite>
            <cite>{{ order.subcustomer && order.subcustomer.name ? ' - '+order.customer.name : '' }}</cite>
        </template>
    </v-select>
</template>

<script>
    import vSelect from 'vue-select';
    import {usePostRequest} from "./compositions/axios/postRequest";
    import Fuse from "fuse.js"

    export default {
        name: "SearchOrderForm",

        components: {
            vSelect,
        },

        setup() {
            const {
                loading: sending,
                errors,
                post
            } = usePostRequest();

            return {
                sending,
                errors,
                post
            };
        },

        data: function () {
            return {
                orders: [],
                search: null,
            };
        },

        props: {
            placeholder: {
                type: String,
                required: true,
            },
        },


        methods: {
            onSearch(search, loading) {
                loading(true);
                this.search = search;
                this.doSearch(loading, search);
            },

            async doSearch(loading, search) {
                if(search) {
                    const data = await this.post(`/espace-employes/commandes/recherche/json`, {
                        search: search
                    });
                    if (data) {
                        this.orders = data.orders.map(function(item, index) {
                            return {
                                index,
                                ...item,
                            }
                        });
                    }
                } else {
                    this.orders = [];
                }
                loading(false);
            },

            onSearchInput(e) {
                if (e.id != null && e.id)  {
                    window.location = '/espace-employes/commandes/preparation/commande/' + e.id;
                }
            },

            fuseOrdersSearchFilter (options, search) {
                const fuse = new Fuse(options, {
                    keys: ['reference', 'name'],
                    shouldSort: true,
                    includeScore: true,
                });
                let fuseList = search.length ? fuse.search(search) : fuse.list;
                let filtered = [];
                for (const key in fuseList) {
                    filtered.push(fuseList[key].item);
                }
                return filtered;
            },
        },
    }
</script>
